import { Box, BoxProps } from '@mui/system'

interface Props {
  children: React.ReactChild | React.ReactChild[]
  sx?: BoxProps
}

const VerticalItem = ({ children, sx }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

export default VerticalItem
